import { Offcanvas } from "react-bootstrap";
import { Sidebar } from "../../components";
import { IoClose } from "react-icons/io5";

type Props = {
  show: boolean;
  handleChangeStore: () => void;
  onLogout: () => void;
  handleClose: () => void;
};

const LeftSidebar: React.FC<Props> = ({
  show,
  handleChangeStore = () => {},
  onLogout,
  handleClose,
}) => {
  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="start"
        style={{ maxWidth: "300px" }}
        className="mobile-sidebar-bg"
      >
        <Offcanvas.Header className="offcanvas-close-button justify-content-end">
          <button
            type="button"
            onClick={handleClose}
            className="btn p-0 border-0 bg-transparent custom-offcanvas-close"
            aria-label="Close"
          >
            <IoClose size={35} />
          </button>
          <Offcanvas.Title></Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="ps-0">
          <Sidebar
            isCollapsed={false}
            onChangeStore={handleChangeStore}
            onLogout={onLogout}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default LeftSidebar;
